export default {"src":"/pro/_next/static/media/sei.02c4e925.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};